jQuery(function ($) {
	if ($('.js-accordion').length > 0) {
		const $accordions = $(".js-accordion");

		// クリック時の開閉
		$accordions.find(".js-accordion__title").on("click", function () {
			$(this).toggleClass("is-open");
			$(this).next(".js-accordion__content").stop().slideToggle();
		});

		// 🔽 初期状態で is-open が付いていたら開いておく
		$accordions.find(".js-accordion__title.is-open").each(function () {
			$(this).next(".js-accordion__content").show();
		});
	}
});
